// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2L22 2V8L2 8L2 2ZM2 10L22 10L22 22L2 22L2 10Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-horizontal-filled')
export default class HorizontalFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'horizontal-filled',
    }
  }
}
